// src/context/AuthContext.js (or wherever you handle user state)
import { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

const AuthContext = createContext();

export function AuthProvider({ children }) {
	const [session, setSession] = useState(null);
	const [user, setUser] = useState(null); // full user
	const [role, setRole] = useState(null); // 'admin' or 'user'
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const getSession = async () => {
			const {
				data: { session },
			} = await supabase.auth.getSession();
			setSession(session);

			if (session?.user) {
				const { data, error } = await supabase
					.from("profiles")
					.select("role")
					.eq("id", session.user.id)
					.single();

				if (error) {
					console.error("Error loading role:", error);
				} else {
					setRole(data.role);
					setUser(session.user);
				}
			}

			setLoading(false);
		};

		getSession();

		const { data: listener } = supabase.auth.onAuthStateChange(
			(_event, session) => {
				setSession(session);
				getSession(); // refetch role if auth state changes
			}
		);

		return () => {
			listener.subscription.unsubscribe();
		};
	}, []);

	async function logout() {
		const { error } = await supabase.auth.signOut();
		if (error) console.error("Logout error:", error);
		// optionally clear user, role, session states here or rely on onAuthStateChange listener
	}

	return (
		<AuthContext.Provider value={{ session, user, role, loading, logout }}>
			{children}
		</AuthContext.Provider>
	);
}

export function useAuth() {
	return useContext(AuthContext);
}
